import { Page, Badge, DataTable, Link, Text, Card, Tooltip, BlockStack } from '@shopify/polaris';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import dateandtime from 'date-and-time';
import helpers from 'helpers/index';
import Pagination from 'components/pagination';
import SimpleFilter from 'components/simpleFilter';
import { Helmet } from 'react-helmet-async';
import __, { ___ } from 'languages/index';
import { TypedOrders, useGetOrders } from 'queries/orders.query';
import { getOrderStatus } from './order.util';

export default function OrderList() {
  const rootSearchPath = window.location.search;
  /**
   * If user apply filter, it will add to URL, then parse URL back to initial state
   */
  let StringQuery: any = helpers.ExtractUrl(rootSearchPath) || false;
  const initialQuery = {
    query: '',
    page: 1,
    limit: 50,
    sort: 'id:desc',
  };
  const [mainQuery, setMainQuery] = useState<any>({
    ...initialQuery,
    ...StringQuery,
  });
  const { refetch: getEntities, data, isFetching: loading } = useGetOrders(mainQuery);

  const [entities, setEntities] = useState<TypedOrders[]>([]);
  const [totalItems, setTotalItems] = useState(0);
  useEffect(() => {
    if (data) {
      let { entities, totalItems } = data;
      setEntities(entities);
      setTotalItems(totalItems);
    }
  }, [data]);
  /**
   * Change page number
   * Must be mainQuery or it will reset mainQuery. BUG!
   */
  const onChangePagination = useCallback((numPage: number, limit: number) => {
    setMainQuery((prevMainQuery) => ({ ...prevMainQuery, page: numPage, limit: limit }));
  }, []);

  const reduceRequest = useCallback((mainQuery) => {
    getEntities();
    return mainQuery;
  }, []);

  const reduceRequestMemo = useMemo(() => {
    return helpers.debounce((_value) => {
      reduceRequest?.call(this, _value);
    }, 500);
  }, []);

  /**
   * I do not know ...
   * Bug: In React, do NOT remove this code
   */
  const filterCallback = useCallback((_value: any) => {
    if (_value === false) {
      return setMainQuery(initialQuery);
    } else {
      setMainQuery((oldValue) => {
        return { ...oldValue, ..._value };
      });
    }
  }, []);

  useEffect(() => {
    let buildURLSearch = helpers.buildEndUrl(mainQuery);
    if (window.location.search !== buildURLSearch) {
      window.history.replaceState(null, 'Orders', '/orders' + buildURLSearch);
    }
    reduceRequestMemo(mainQuery);
  }, [mainQuery]);

  const styles: any = {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    width: '200px',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    whiteSpace: 'pre-line',
    overflow: 'auto',
  };

  return (
    <>
      <Helmet>
        <title>Danh sách đơn hàng</title>
      </Helmet>
      <Page
        title="Danh sách đơn hàng"
        fullWidth
        // primaryAction={{
        //   content: 'Thêm vé',
        //   icon: PlusIcon,
        //   onAction: () => toggleCreateModalActive(),
        // }}
      >
        <Card padding="0">
          <SimpleFilter
            loading={loading}
            options={[]}
            onCallback={filterCallback}
            sortField={[
              {
                label: 'Ngày đi',
                field: 'departure_date',
              },
            ]}
          />
          <DataTable
            verticalAlign="middle"
            hideScrollIndicator={true}
            stickyHeader
            increasedTableDensity
            columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text', 'text']}
            headings={[
              'Code',
              'Khách hàng',
              'Ngày đi',
              'Hành trình',
              'Số vé',
              'Tài xế',
              'Điểm đón trả',
              'Số tiền',
              'Ghi chú',
              'Người đặt',
              'Thanh toán',
              'Vận chuyển',
              'Ngày tạo',
            ]}
            rows={
              entities?.map((order) => {
                const {
                  id,
                  order_code,
                  customer_data,
                  departure_date,
                  dropoff_address,
                  pickup_address,
                  journey,
                  total_must_pay,
                  note,
                  author_data,
                  order_status,
                  total_seat,
                  payment_status,
                  journey_id,
                  createdAt,
                  ticket,
                } = order;

                let trip_hour = dateandtime.format(new Date(Number(departure_date)), 'HH:mm');
                let trip_date_reformat = dateandtime.format(new Date(Number(departure_date)), 'YYYY-MM-DD');
                let allDrivers = [];
                let trip_manifest_ticket = null;

                if (ticket && typeof ticket[0] !== 'undefined') {
                  trip_manifest_ticket = ticket[0]?.trip_manifest_ticket;
                  allDrivers = trip_manifest_ticket?.trip_manifest?.trip_manifest_driver || null;
                }

                return [
                  //   <Link
                  //     removeUnderline
                  //     // url={`#order_id:${id}`}
                  //     url={`/ticket_managers?d=${trip_date_reformat}&journey_id=${journey_id}&htext=${trip_hour}&h=${trip_manifest_ticket?.trip_manifest?.time_id}#${id}`}
                  //   >
                  //     <strong>{order_code}</strong>
                  //   </Link>,
                  <Link
                    removeUnderline
                    // url={`#order_id:${id}`}
                    url={`/orders/view/${id}`}
                  >
                    <strong>{order_code}</strong>
                  </Link>,
                  customer_data ? (
                    <>
                      <Link removeUnderline url={`/customer/view/${customer_data?.user_id}`}>
                        <Tooltip content={customer_data?.display_name}>
                          <p style={{ ...styles, maxWidth: '100px', fontWeight: 'bold' }}>{customer_data?.display_name}</p>
                        </Tooltip>
                      </Link>
                      {customer_data?.user_phonenumber && (
                        <Link url={`tel:${customer_data?.user_phonenumber}`}>
                          <Text as="p">{customer_data?.user_phonenumber}</Text>
                        </Link>
                      )}
                    </>
                  ) : (
                    '--'
                  ),
                  <>
                    <Text as="h3" variant="headingMd">
                      {trip_hour}
                    </Text>
                    <Text as="p" tone="subdued">
                      {trip_date_reformat}
                    </Text>
                  </>,
                  journey ? <Text as="span">{journey?.journey_name}</Text> : '--',
                  total_seat,

                  !helpers.isEmpty(allDrivers)
                    ? allDrivers.map((al: any) => (
                        <div>
                          {al.driver_data.display_name} ({al.driver_data.user_phonenumber})
                        </div>
                      ))
                    : '-',
                  <BlockStack>
                    <Text as="p">{pickup_address || ''}</Text>
                    <Text as="p">{dropoff_address || '-'}</Text>
                  </BlockStack>,

                  helpers.formatNumber(total_must_pay),

                  note ? (
                    <Tooltip content={note}>
                      <p style={styles}>{note}</p>
                    </Tooltip>
                  ) : (
                    '--'
                  ),
                  author_data?.display_name ?? '--',
                  <Badge tone={payment_status === 0 ? 'critical' : 'success-strong'}>
                    {payment_status === 0 ? 'PENDING' : payment_status === 1 ? 'OK' : 'REFUND'}
                  </Badge>,
                  getOrderStatus(order_status),
                  <>
                    <Text as="h3" variant="headingMd">
                      {dateandtime.format(new Date(Number(createdAt)), 'HH:mm')}
                    </Text>
                    <Text as="p" tone="subdued">
                      {dateandtime.format(new Date(Number(createdAt)), 'DD-MM-YYYY')}
                    </Text>
                  </>,
                ];
              }) || []
            }
            footerContent={___('Show page {display_page_number} of {total_record_number} results', {
              display_page_number: <Text as="strong">{mainQuery?.page || 1}</Text>,
              total_record_number: <Text as="strong">{totalItems}</Text>,
            })}
          />
        </Card>

        <br />
        {totalItems > 0 ? (
          <Pagination
            TotalRecord={totalItems}
            onChange={onChangePagination}
            pageSize={Number(mainQuery?.limit)}
            activeCurrentPage={Number(mainQuery?.page)}
          />
        ) : null}
      </Page>
      <br />
      <br />
      <br />
      <br />
    </>
  );
}

